import { render, staticRenderFns } from "./ContentBlacklistCandidate.vue?vue&type=template&id=0387fbd5&scoped=true"
import script from "./ContentBlacklistCandidate.vue?vue&type=script&lang=js"
export * from "./ContentBlacklistCandidate.vue?vue&type=script&lang=js"
import style0 from "./ContentBlacklistCandidate.vue?vue&type=style&index=0&id=0387fbd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387fbd5",
  null
  
)

export default component.exports